import ActionTypes from "../constant/constant";


function registerForm(obj) {
  console.log('registerForm')
  return (dispatch) => {

  };
}



export { registerForm };
